const editorAccordion = {
    _accordions: null,

    init() {
        let self = this;

        if(document.querySelectorAll('.editor-accordion').length > 0) {
            self._construct();
        }
    },

    _construct() {
        let self = this;
        self._accordions = document.querySelectorAll('.editor-accordion');
        self._accordions.forEach(accordion => {
            
            if(accordion.dataset.initalized === '1') {
                return;
            }

            const accordionHeading = accordion.querySelector('.editor-accordion__heading');
            self._changeTag('summary', accordionHeading);
            self._changeTag('details', accordion);
            accordion.dataset.initalized = '1';
        });
    },

    _changeTag(tagName, oldNode) {
        const newTag = document.createElement(tagName);
        newTag.classList.add(oldNode.className);
        newTag.innerHTML = oldNode.innerHTML;
        oldNode.parentNode.insertBefore(newTag, oldNode);
        oldNode.parentNode.removeChild(oldNode);
    }
};

editorAccordion.init();

document.addEventListener('LokiRequestEnd', function () {
    editorAccordion.init();
});